import reducer from "./reducers";

import * as ventasOps from "./operations";
import * as ventasTypes from "./types";

export { ventasOps, ventasTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventas/index.js